/**
 * 官网营业时间（匿名接口）
 * @returns {Promise<Array>}
 */
export function fetchPublicWorkHours() {
  const prefix = process.env.VUE_APP_BASE_API || ''
  return fetch(prefix + '/web/workHours/public', {
    method: 'GET',
    headers: { Accept: 'application/json' },
  })
    .then((res) => res.json())
    .then((body) => {
      if (body.code !== 200) {
        throw new Error(body.msg || '加载失败')
      }
      return Array.isArray(body.data) ? body.data : []
    })
}
